import type { FC } from 'react';
import { buildMeetingUrl } from '../../../../utils/url';
import type { MeetingListProps } from '../../types';
import EmptyState from './EmptyState';
import MeetingItem from './MeetingItem';

const MeetingList: FC<MeetingListProps> = ({
  meetings,
  selectedRoom,
  onSelect,
  canCreate,
  disabledReason,
  isFreePlan,
  baseJoinUrl,
  defaultMeetingId,
}) => {
  if (meetings.length === 0) {
    return (
      <EmptyState canCreate={canCreate} disabledReason={disabledReason} isFreePlan={isFreePlan} />
    );
  }

  return (
    <div className="personal-meetings-modal__meeting-section">
      {meetings.map((meeting) => (
        <MeetingItem
          key={meeting.room}
          meeting={meeting}
          isSelected={selectedRoom === meeting.room}
          isDefault={defaultMeetingId === meeting.room}
          onSelect={onSelect}
          joinUrl={buildMeetingUrl(baseJoinUrl, meeting)}
        />
      ))}
    </div>
  );
};

export default MeetingList;
